/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react';
import 'moment/locale/pt';

import { Box, Button, List, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';

export default function ChangedAmountYieldListModal({ onClose, yieldsList, liquidateCPR }) {

  const handleReturnInfos = () => {
    liquidateCPR()
    onClose()
  }

  return (
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      boxShadow: 24,
      borderRadius: 2,
      backgroundColor: grey[300]
    }}>
      <Box sx={{
        padding: '16px',
        borderRadius: '8px 8px 0 0',
        backgroundColor: '#fff'
      }}>
        <Typography variant="h6" component="h2">
          Confirme a liquidação dos seguintes cupons
        </Typography>
      </Box>

      <Box sx={{
        margin: '16px',
        width: 700,
        height: '200px',
        backgroundColor: '#fff',
        borderRadius: 1,
        height: '100%'
      }}>
        <List
          sx={{
            width: '100%',
            maxWidth: '100%',
            bgcolor: 'background.paper',
            position: 'relative',
            overflow: 'auto',
            maxHeight: 750,
            paddingX: 2,
          }}
          subheader={<li />}
        >
          {yieldsList.map((item) => (
            <li key={`section-${item.id}`}>
              <Box sx={{
                marginY: 2,
                borderBottom: '1px solid'
              }}>
                <Typography component="h2">
                  Cupom: {item.id}
                </Typography>
                <Typography component="h2">
                  {`Valor original: ${Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(item.old_amount_cpr_installment)}`}
                </Typography>
                <Typography component="h2">
                  {`Valor final: ${Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(item.amount_cpr_installment)}`}
                </Typography>
                {
                  item.amortization && (
                    <Typography component="h2">
                      {`Valor de amortização: ${Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(item.amortization)}`}
                    </Typography>
                  )
                }
                
              </Box>
            </li>
          ))}
        </List>
      </Box>

      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
        gap: 1,
        padding: 2,
        borderRadius: '0 0 8px 8px',
        backgroundColor: '#fff'
      }}>
        <Button variant="contained" color={'success'} onClick={() => handleReturnInfos()}>
          <Typography color={'#fff'}>
            Confirmar
          </Typography>
        </Button>
        <Button variant="contained" onClick={onClose}>
          <Typography color={'#fff'}>
            Fechar
          </Typography>
        </Button>
      </Box>
    </Box>
  )
}
